module.exports = __webpack_public_path__ + "images/landing/video-previews/How_to_Create_Whiteboard_Animation_with_Animatron_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/How_to_Create_Whiteboard_Animation_with_Animatron_2x.jpg
// module id = irt1
// module chunks = 1